import { QuotationsService } from '@pages/quotations';
import { Observable, combineLatest, map, of, startWith } from 'rxjs';

import { Note } from '@shared-models';

// Shared by the card footer's note indicator and the card body's notes
// section so both stay driven by the same credit/debit note query instead
// of drifting apart or relying on a notes prop passed down from the parent.
export const getRelatedNotes$ = (
  quotationsService: QuotationsService,
  idInvoice: number | undefined,
): Observable<Note[]> => {
  if (!idInvoice) return of<Note[]>([]);

  return combineLatest([
    quotationsService.getCredito(idInvoice).pipe(startWith([])),
    quotationsService.getDebito(idInvoice).pipe(startWith([])),
  ]).pipe(map(([credit, debit]) => [...credit, ...debit]));
};
